import { DropdownType, PrinterType, TrayPaperSizeType } from './types';

export const getPaperSizeOptions = (printer: PrinterType): DropdownType[] => {
  const paperSizeSet = new Set();
  const options: DropdownType[] = [];
  printer.trayPaperSizeMappings.forEach(tray =>
    paperSizeSet.add(tray.paperSize)
  );
  paperSizeSet.forEach(paperSize => {
    const objOption: DropdownType = {
      label: paperSize as string,
      value: paperSize as string
    };
    options.push(objOption);
  });
  return options;
};

export const getTrayOptions = (
  printer: PrinterType,
  paperSize: DropdownType | undefined
): TrayPaperSizeType[] => {
  const options: TrayPaperSizeType[] = [];
  printer.trayPaperSizeMappings.forEach(tray => {
    if (paperSize?.value === '' || tray.paperSize === paperSize?.value) {
      options.push(tray);
    }
  });
  return options;
};

export const defaultPrinter = {
  printerId: '',
  vendorPrinterId: '',
  printerName: '',
  printerAlias: '',
  printerModel: '',
  storeId: '',
  departments: [],
  trayPaperSizeMappings: [],
  links: [],
  printerIP: ''
};
